<template>
    <div>
        <div class="content-caption dashed">
            <span>付款详情</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>付款单据号</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.no }}</span>
                    <el-tag class="ml10" type="danger" v-if="payVoucher.prePayFlag">预付</el-tag>
                </div>
            </div>
            <div class="form-group center" v-if="optionFlag == 'chaKan'">
                <div class="form-label">
                    <label>外部付款凭证号</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.reservedPayNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>来源类型</label>
                </div>
                <div class="form-value">
                    <span>{{ srcVoucherTypeMap[payVoucher.srcVoucherType] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>来源单据号</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.srcVoucherInnerNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款主题</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.subject }}</span>
                </div>
            </div>
            <div class="form-group center" v-if="optionFlag != 'fuKuan'">
                <div class="form-label">
                    <label>付款状态</label>
                </div>
                <div class="form-value">
                    <div class="content" v-if="payVoucher.payResult == 0">待付款</div>
                    <div class="content" v-else>{{ payResultMap[payVoucher.payResult] }}</div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款银行</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.payBankName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款卡号</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.payCardNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款账号</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.payAcctNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款途径</label>
                </div>
                <div class="form-value">
                    <span>{{ payWayMap[payVoucher.payWay] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款方式</label>
                </div>
                <div class="form-value">
                    <span>{{ payMethodMap[payVoucher.payMethod] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款形式</label>
                </div>
                <div class="form-value">
                    <span>{{ payFormMap[payVoucher.payForm] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款方</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.rcverRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款方标识码</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.rcverInnerNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款银行</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.rcvBankName || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款卡号</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.rcvCardNo || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款账号</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.rcvAcctNo || '' }}</span>
                </div>
            </div>
            <div class="form-group center" v-if="payVoucher.payPhaseId != -1">
                <div class="form-label">
                    <label>当前付款阶段</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.payPhaseName || '' }} (付款比例{{ (payVoucher.ratio || 0).toFixed(2) }}%)</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>本次需付金额</label>
                </div>
                <div class="form-value">
                    <span class="font-red font16" v-if="payVoucher.prePayFlag"><b>{{ (parseFloat(payVoucher.amountPre || 0)).toFixed(2) }}</b> 元</span>
                    <span class="font-red font16" v-else><b>{{ (parseFloat(payVoucher.amount || 0)).toFixed(2) }}</b> 元</span>
                    <!--               6.14.7版本不实现，后续再考虑 TODO 2025-05-20       -->
                    <!--                    <span class="swb-btn swb-btn-link" @click="exportPdf" v-if="payVoucher.srcVoucherType == 1 && payVoucher.srcVoucherId != null && payVoucher.srcVoucherId != -1">付款单下载</span>-->
                </div>
            </div>
        </div>
        <div class="table-layout" v-if="payItems != null && payItems.length > 0">
            <el-table :data="payItems" border style="width: 100%">
                <el-table-column align="left" prop="payPhaseName" label="阶段名称"></el-table-column>
                <el-table-column align="right" prop="amount" label="本次需付款金额(元)" width="200">
                    <template slot-scope="scope">
                        <span>{{ (scope.row.amount || 0).toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="amount" label="本次实际付款金额(元)" width="200">
                    <template slot-scope="scope">
                        <span>{{ (scope.row.amount || 0).toFixed(2) }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="simple-form" v-if="!payVoucher.prePayFlag">
            <div class="form-group center">
                <div class="form-label">
                    <label>本次实际付款金额</label>
                </div>
                <div class="form-value">
                    <span class="font-red font16" v-if="payVoucher.prePayFlag"><b>{{ (parseFloat(payVoucher.amountPre || 0)).toFixed(2) }}</b> 元</span>
                    <span class="font-red font16" v-else><b>{{ (parseFloat(payVoucher.amountPost || 0)).toFixed(2) }}</b> 元</span>
                </div>
            </div>
        </div>
        <div class="simple-form">
            <div class="form-group center" v-if="optionFlag == 'shenHe'">
                <div class="form-label">
                    <label>申请状态</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.applyStateText }}</span>
                </div>
            </div>
            <div class="form-group center" v-if="optionFlag != 'shenHe'">
                <div class="form-label">
                    <label>审核状态</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.auditStateText }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请描述</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.applyDesc }}&nbsp;</span>
                </div>
            </div>
            <div class="form-group center" v-if="optionFlag != 'shenHe'">
                <div class="form-label">
                    <label>审核描述</label>
                </div>
                <div class="form-value">
                    <span>{{ payVoucher.auditDesc }}</span>
                </div>
            </div>
        </div>
        <el-form :model="payVoucher" :rules="checkPay" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>留言</label>
                    </div>
                    <div class="form-value width-2x" v-if="optionFlag == 'fuKuan'">
                        <el-form-item prop="memo">
                            <el-input placeholder="请输入" type="textarea" v-model="payVoucher.memo"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-value width-1-5x" v-if="optionFlag != 'fuKuan'">
                        <span>{{ payVoucher.memo }}</span>
                    </div>
                </div>
            </div>
            <div class="simple-form" v-if="optionFlag == 'shenHe'">
                <div class="form-group center">
                    <div class="form-label">
                        <label>审核结果</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-radio-group v-model="payVoucher.auditState" v-if="optionFlag != 'chaKan'">
                            <el-radio v-for="auditStateInfo in auditStateList" :label="auditStateInfo.value">
                                <span>{{ auditStateInfo.text }}</span>
                            </el-radio>
                        </el-radio-group>
                        <span v-else>{{ auditStateMap[payVoucher.auditState] }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>审核描述</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="auditDesc" v-if="optionFlag != 'chaKan'">
                            <el-input placeholder="请输入" type="textarea" v-model="payVoucher.auditDesc"></el-input>
                        </el-form-item>
                        <span v-else>{{ payVoucher.auditDesc }}</span>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import {Utils} from '../../app.base'
import {Vue, MsgBox, Routes} from '../../app.vues'
import {openPayVoucherInfoPdfDlg} from './ActRecDlg'

import finacApi from '../../api/finac'

export default {
    name: 'swb-pay-voucher-info',
    desc: '付款单据详情',
    props: ['voucherId', 'optionFlag'],
    data: function () {
        let self = this;
        let checkLength = function (rule, value, callback) {
            let field = rule.field;
            if (Utils.isNoB(value)) {
                callback();
            } else {
                if (field == 'memo') {
                    if (value.length > 60) {
                        callback(new Error('留言最多不能超过60个字'));
                    } else {
                        callback();
                    }
                } else if (field == 'auditDesc') {
                    if (value.length > 250) {
                        callback(new Error('审核描述最多不能超过250个字'));
                    } else {
                        callback();
                    }
                }
            }
        }
        return {
            payVoucher: {
                auditState: getEnumInfoWith('auditState', 'name', 'AuditPass').value
            },
            payItems: [], // 付款项
            auditStateList: [],
            auditStateMap: getEnumMap('auditState', 'value2text'),
            srcVoucherTypeMap: getEnumMap("srcVoucherType", "value2text"),
            payResultMap: getEnumMap("resultState", "value2text"),
            payWayMap: getEnumMap("payWay", "value2text"),
            payFormMap: getEnumMap("payForm", "value2text"),
            payMethodMap: getEnumMap("payMethod", "value2text"),
            // 校验
            checkPay: {
                memo: [{
                    validator: checkLength,
                    trigger: 'blur'
                }],
                auditDesc: [{
                    validator: checkLength,
                    trigger: 'blur'
                }]
            }
        }
    },
    created: function () {
        //
        this.auditStateList = getEnumInfoWith('auditState', 'name', ['AuditFail', 'AuditPass']);
        //
        this.getPayVoucherInfo();
    },
    methods: {
        // 获取付款单详情
        getPayVoucherInfo: function () {
            let self = this;
            let postData = {};
            postData.id = self.voucherId;
            //
            let msgBoxDlg = MsgBox.loading();
            finacApi.getPayVoucher(postData, function (result) {
                msgBoxDlg.close();
                if (result.type == 'info') {
                    let payVoucher = result.data;
                    //
                    let applyStateInfo = getEnumInfoWith('applyState', 'value', payVoucher.applyState);
                    if (!Utils.isNoB(applyStateInfo)) {
                        payVoucher.applyStateText = applyStateInfo.text;
                    }
                    // 审核状态处理
                    if (self.optionFlag != 'shenHe') {
                        if (payVoucher.applyState == 0) {
                            payVoucher.auditStateText = '未申请';
                        } else if (payVoucher.applyState == 1 && payVoucher.auditState == 0) {
                            payVoucher.auditStateText = '待审核';
                        } else if (payVoucher.applyState == 2 && payVoucher.auditState == 1) {
                            payVoucher.auditStateText = '审核通过';
                        } else if (payVoucher.applyState == 2 && payVoucher.auditState == -1) {
                            payVoucher.auditStateText = '审核未通过';
                        }
                    }
                    payVoucher.amountPost = parseFloat(payVoucher.amountPost || 0).toFixed(2);
                    //
                    if (!Utils.isNoB(self.optionFlag) && self.optionFlag == 'fuKuan') {
                        payVoucher.usePrePay = false;
                    }
                    //
                    let payItems = [];
                    //
                    let payItem = {
                        payPhaseName: payVoucher.payPhaseName,
                        amount: payVoucher.amount
                    };
                    payItems.push(payItem);
                    //
                    self.payItems = Utils.merge([], payItems);
                    self.payVoucher = Utils.merge({}, payVoucher);
                    self.payVoucher.auditState = getEnumInfoWith('auditState', 'name', 'AuditPass').value;
                    //
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        // 付款
        getDlgResult: function () {
            let result = {};
            let payVoucher = this.payVoucher || {};
            let payItems = this.payItems || [];
            if (Utils.isTrue(payVoucher.usePrePay)) {
                // 表单校验
                this.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        if (Utils.isNoB(payVoucher.useVoucherId)) {
                            result.type = 'warn';
                            result.message = '请选择预付单！';
                        } else {
                            //
                            payVoucher.payItems = payItems;
                            result.data = payVoucher;
                            result.type = 'info';
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败！';
                    }
                });
            } else {
                let errMsg = '';
//                let needUpdateAmount = false;
//                for(let i = 0; i < payItems.length; i++) {
//                    let payItem = payItems[i];
//                    if(Utils.isNoB(payItem.currAmount)) {
//                        errMsg = "本次实际付款金额不可为空";
//                        break;
//                    }
//                    if(parseFloat(payItem.currAmount) != parseFloat(payItem.amount)) {
//                        needUpdateAmount = true;
//                    }
//                    payItem.realAmount = payItem.currAmount;
//                }

                if (!Utils.isNoB(errMsg)) {
                    result.type = 'warn';
                    result.message = errMsg;
                } else {
//                    payVoucher.needUpdateAmount = needUpdateAmount;
                    payVoucher.payItems = payItems;
                    result.data = payVoucher;
                    result.type = 'info';
                }
            }
            return result;
        },
        exportPdf: function () {
            openPayVoucherInfoPdfDlg(this.voucherId, true);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/payment/PayVoucherInfo.vue